import { RouteItem } from '@eastcoal/router/types/route'

import { SECRET_AUCTION_CREATE_PAGE_PATH } from '../constants/path'

export const secretAuctionCreateRoute: RouteItem = {
  title: '新增密函',
  hideInMenu: true,
  path: SECRET_AUCTION_CREATE_PAGE_PATH,
  Component: () => import('./index')
}
